// extracted by css-extract-rspack-plugin
export default {"bracket-connector":"uIQv11Ov"};